var map = {
	"./1 Thumbnail, title_ BNN Dilengkapi Teknologi Informasi yang Canggih.jpg": 38242,
	"./2 Thumbnail, title_ PBB UNDANG BNN RI DALAM PERTEMUAN TAHUNAN DI GENEVA SWITZERLAND TAHUN 2020.jpg": 47692,
	"./3 Thumbnail, title_ Puslitdatin BNN dan Politeknik Statistika STIS Sepakati Kerja Sama Lakukan Penelitian Indeks P4GN.jpg": 56177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20147;